"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.checkAuthenticationCommand = void 0;var _command = require("./command");
var _url = require("../utils/url");
var _const = require("../const");
var _redeemCode = require("./redeemCode");
var _authorize = require("./authorize");
var _clientState = require("../utils/clientState");
var _callbacks = require("../utils/callbacks");



var _logging = require("../utils/logging");

/**
 * checks if the current user is authenticated by querying  api
 * - there are 3 paths:
 *      1) A new auth code is in query string - redeems code for tokens
 *      2) Auth tokens exist - calls component API to verify tokens are still valid
 *      3) Auth tokens and code do not exist - user is not authenticated and is optionally redirected to login page
 * @param id - command ID
 * @param config
 * @param state
 * @param options
 * @param encodedClientState - encoded client state - will be returned in response
 */
const checkAuthenticationCommand = (id, config, state, options, encodedClientState) => {var _state$currentAuthent;
  options.redirect = options.redirect ?? true;
  const { redirectUri, unifiedLoginUrl } = config;

  //1. attempt code exchange
  const code = (0, _url.getValueFromQueryString)(_const.QS_AUTH_CODE);
  if (code) {
    (0, _redeemCode.redeemAuthenticationCodeCommand)(id, config, state, code, encodedClientState);
    return;
  }

  //2. Auth tokens exist - If we have at least the refreshToken, we can refresh the user's credentials
  if ((_state$currentAuthent = state.currentAuthentication) !== null && _state$currentAuthent !== void 0 && _state$currentAuthent.refreshToken) {
    config.authenticationFrame.contentWindow.postMessage(
      new _command.Command(config.clientType, _command.Command.Commands.checkAuthentication, {
        id,
        redirectUnauthenticated: options.redirect,
        redirectionReturnUrl: unifiedLoginUrl,
        authentication: state.currentAuthentication,
        redirectUri,
        clientState: encodedClientState
      }),
      '*'
    );
    return;
  }

  //3. Unauthenticated
  _logging.Logger.debug('unauthenticated');
  if (options.redirect) {
    (0, _authorize.authorizeCommand)(config, options.username, encodedClientState);
  } else {
    // handle unauthenticated with no redirect
    (0, _callbacks.makeCallbacks)(id, config.callbacks, {
      response: _command.Command.CommandResponses.checkAuthentication,
      responseDetails: {
        id,
        isAuthenticated: false,
        success: true,
        //this is a response, so we need to decode state
        clientState: (0, _clientState.decodeAndParse)(encodedClientState)
      }
    });
  }
};exports.checkAuthenticationCommand = checkAuthenticationCommand;